<template>
  <ion-page>
    <ion-header no-border class="bar-header" v-if="!otpMode">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-back-button default-href="/"></ion-back-button>
        </ion-buttons>
        <ion-title class="ion-no-padding">{{ $t('set_pwd') }}</ion-title>
      </ion-toolbar>
    </ion-header>
    <ion-content fullscreen="true" class="content" v-if="!otpMode">
      <div id="home-container">
        <div class="logo-container"></div>
        <div class="flex">
          <ion-text class="title">{{ $t('dont_have_pwd') }}</ion-text>
          <ion-text class="description">{{ $t('enter_your_mobile_number_to_set_pwd') }}</ion-text>
          <Form @submit="onNext" v-slot="{ meta }">
            <Field
              v-model="phoneNumber"
              name="phoneNumber"
              :label="$t('mobile_number')"
              :rules="{ required: true, phoneValidator: true }"
              v-slot="{ field }"
            >
              <ion-item
                class="box phone-number-group"
                lines="none"
                :class="{
                  error: !mobileErrorMsg ? false : true
                }"
              >
                <ion-label class="hidden">{{ $t('country_code') }}</ion-label>
                <vue-tel-input
                  v-model="phoneNumber"
                  mode="national"
                  enabledCountryCode
                  enabledFlags
                  validCharactersOnly
                  ref="phone-field"
                  pattern="[0-9]*$"
                  styleClasses="no-border	no-box-shadow "
                  disabledFetchingCountry
                  :autoDefaultCountry="false"
                  :defaultCountry="defaultCountryCode"
                  :autoFormat="false"
                  @on-input="onInput"
                  @country-changed="countryChange"
                  @keypress="blockDecimalInput"
                  :inputOptions="{
                    type: 'tel',
                    maxlength: 16,
                    placeholder: 'Mobile Number'
                  }"
                  :onlyCountries="getPreferedCountryCode()"
                  @open="handleOpenDropdown()"
                  @close="handleCloseDropdown()"
                />
                <input v-bind="field" type="tel" maxlength="16" style="display: none" />
              </ion-item>
            </Field>
            <div class="button-groups t-m-2">
              <ion-button class="home-btn" expand="block" :disabled="!meta.valid" type="submit">
                <span>{{ $t('send_verification_code') }}</span>
              </ion-button>
              <ion-label class="signup-link"
                >{{ $t('dont_have_an_account') }}
                <router-link to="/shared/auth/signup-info"
                  ><strong>{{ $t('sign_up') }}</strong></router-link
                >
              </ion-label>
            </div>
          </Form>
          <ion-text v-if="mobileErrorMsg" class="ml-2 fs-12px text-danger">
            {{ mobileErrorMsg }}
          </ion-text>
        </div>
      </div>
    </ion-content>
    <Otp
      v-if="otpMode"
      :openToast="openToast"
      :toastMsg="$t('phone_verified')"
      :title="$t('set_pwd')"
      :countryCode="countryCode"
      :phoneNumber="phoneNumber"
      :showError="otpError"
      @cancelOtp="
        otpMode = false;
        otpError = false;
      "
      @onSubmitOtpCode="setPasswordOtp"
      @resendCode="resendOtp"
    ></Otp>
    <ion-modal :is-open="isOtpSuspend">
      <otp-suspend @cancelOtp="isOtpSuspend = false" />
    </ion-modal>
    <ion-loading
      :is-open="isOpenLoadingref"
      cssClass="custom-loading"
      message=""
      spinner="crescent"
      @didDismiss="setOpenLoading(false)"
    >
    </ion-loading>
  </ion-page>
</template>
<script>
import Otp from '@/components/Otp';
import OtpSuspend from '@/components/OtpSuspend';
import { apolloClient } from '@/main';
import { preferredCountryCode } from '@/services/shared/helper/home';
import { useQuery, useResult } from '@vue/apollo-composable';
import { Field, Form } from 'vee-validate';
import { defineComponent, inject, reactive, ref, toRefs } from 'vue';
import { useRouter } from 'vue-router';
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';
import { countries, getUserByMobile } from '../../../../services/shared/graphql';

import { getDefaultCountryCode, getPreferedCountryCode } from '@/modules/sale/services/libs/helper';

export default defineComponent({
  name: 'SetPassword',
  components: {
    Field,
    Form,
    VueTelInput,
    Otp,
    OtpSuspend
  },
  ionViewDidEnter() {
    this.resetState();
  },
  data: () => ({
    isDropdown: false
  }),
  setup() {
    const storage = inject('$storage');
    const state = reactive({
      phoneNumber: '',
      defaultCountryCode: 'SG',
      otpError: false,
      otpMode: false,
      openToast: false,
      mobileErrorMsg: ``
    });
    const { defaultCountryCode, phoneNumber, otpError, otpMode, openToast, mobileErrorMsg } = toRefs(state);
    const vform = reactive({});
    const router = useRouter();
    const isOtpSuspend = ref(false);
    const countryCode = ref(preferredCountryCode[0]);
    const { result } = useQuery(countries);
    const allCountries = useResult(result, null, (data) => data.allCountries);
    const setOpenToast = (state) => (openToast.value = state.openToast);
    const resetState = () => {
      if (phoneNumber.value) {
        defaultCountryCode.value = 'SG';
        phoneNumber.value = '';
        otpError.value = false;
        otpMode.value = false;
        openToast.value = false;
        countryCode.value = preferredCountryCode[0];
      }
    };

    const isOpenLoadingref = ref(false);
    const setOpenLoading = (state) => {
      isOpenLoadingref.value = state;
    };

    const onNext = async (values, actions) => {
      vform.values = values;
      vform.actions = actions;
      const fullPhoneNumber = `${parseInt(countryCode.value)}${vform.values.phoneNumber}`;
      if (fullPhoneNumber) {
        setOpenLoading(true);
        try {
          const { errors } = await apolloClient.query({
            query: getUserByMobile,
            variables: {
              mobile: fullPhoneNumber
            }
          });
          if (errors) {
            mobileErrorMsg.value = errors[0].message;
            setOpenLoading(false);
            return;
          }

          otpMode.value = true;
          setOpenLoading(false);
        } catch (error) {
          if (error.message.includes(`too many`)) {
            isOtpSuspend.value = true;
            setOpenLoading(false);
          } else {
            setOpenLoading(false);
            vform.actions.setFieldError('phoneNumber', error.message);
          }
        }
      }
    };
    const setPasswordOtp = async (otp) => {
      const phoneNumber = `${parseInt(countryCode.value)}${vform.values.phoneNumber}`;
      try {
        setOpenLoading(true);
        const { data } = await apolloClient.query({
          query: getUserByMobile,
          variables: {
            mobile: phoneNumber,
            otp: otp
          }
        });
        setOpenToast(true);
        await storage.setUserResetPass({
          email: data.getUserByMobile.email,
          userId: data.getUserByMobile.id
        });
        router.push({
          name: 'ResetPassword'
        });
        setOpenLoading(false);
      } catch (error) {
        if (error.message.includes(`too many`)) {
          isOtpSuspend.value = true;
          setOpenLoading(false);
        } else {
          setOpenLoading(false);
          otpError.value = true;
        }
      }
    };

    const resendOtp = async () => {
      const fullPhoneNumber = `${parseInt(countryCode.value)}${vform.values.phoneNumber}`;
      if (fullPhoneNumber) {
        setOpenLoading(true);
        try {
          await apolloClient.query({
            query: getUserByMobile,
            variables: {
              mobile: fullPhoneNumber
            }
          });
          setOpenLoading(false);
        } catch (error) {
          if (error.message.includes(`too many`)) {
            setOpenLoading(false);
            isOtpSuspend.value = true;
          } else {
            setOpenLoading(false);
            otpError.value = true;
          }
        }
      }
    };

    return {
      mobileErrorMsg,
      phoneNumber,
      defaultCountryCode,
      getPreferedCountryCode,
      otpError,
      otpMode,
      countryCode,
      onNext,
      openToast,
      allCountries,
      setPasswordOtp,
      setOpenToast,
      resetState,
      isOpenLoadingref,
      setOpenLoading,
      resendOtp,
      isOtpSuspend
    };
  },
  mounted() {
    this.$refs['phone-field'].choose('SG');
    this.$refs['phone-field'].focus();
  },
  methods: {
    onInput(val) {
      this.mobileErrorMsg = ``;
      let input = val.toString();
      input = input.replace(/^0+|^,|^\.+/g, '');
      input = input.replace(/[^\d.,]/g, '');
      input = input.replace(/[.,]/g, '');
      this.phoneNumber = input;
    },

    blockDecimalInput(event) {
      // block decimal and only allow number
      let keyCode = event.keyCode ? event.keyCode : event.which;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    countryChange(val) {
      this.defaultCountryCode = val.iso2;
      this.countryCode = val.dialCode || getDefaultCountryCode();
      this.$refs['phone-field'].focus();
    },

    handleOpenDropdown() {
      this.isDropdown = true;
    },
    handleCloseDropdown() {
      this.isDropdown = false;
    }
  }
});
</script>
<style lang="scss" scoped>
@import '@/views/Home/home.scss';
@import 'SetPassword.scss';
ion-select::part(icon) {
  background-repeat: no-repeat;
  width: 18px;
}
ion-select {
  margin-left: 10px;
  color: #9ca3af !important;
}
ion-select ~ .phone-number {
  margin-left: 4px;
}
</style>
